export default __webpack_public_path__ + "计算界面-引导图片4.png";